import { useEffect, useState } from "react";

export function useFullScreen() {
  const [isFullScreen, setIsFullScreen] = useState(
    !!document.fullscreenElement
  );

  const toggleFullScreen = () => {
    if (!isFullScreen) {
      document.documentElement.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
  };

  const startFullScreen = () => {
    if (!isFullScreen) document.documentElement.requestFullscreen();
  };

  const exitFullscreen = () => {
    if (isFullScreen) document.exitFullscreen();
  };

  useEffect(() => {
    const handleFullScreenChange = () => {
      setIsFullScreen(!!document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", handleFullScreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullScreenChange);
    };
  }, []);

  return { isFullScreen, toggleFullScreen, startFullScreen, exitFullscreen };
}
